import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, Schemas, LingoApiResponse } from "@thenounproject/lingo-core";
import qs from "query-string";
import * as actionTypes from "../actions/actionTypes";

const { CALL_API } = API;

export const fetchAsset = (assetId: string, shareToken?: string) => {
  const queryString = qs.stringify({
    asset_token: shareToken,
  });
  return {
    uuid: assetId,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_ASSET,
        actionTypes.FETCH_ASSET_SUCCESS,
        actionTypes.FETCH_ASSET_FAILURE,
      ],
      endpoint: `assets/${assetId}?${queryString}`,
      method: "GET",
      schema: Schemas.ASSET,
    },
  };
};

const useFetchAsset = () => {
  const dispatch = useDispatch();
  return useCallback(
    (assetId: string, shareToken?: string) => {
      return dispatch(fetchAsset(assetId, shareToken)) as unknown as Promise<LingoApiResponse>;
    },
    [dispatch]
  );
};
export default useFetchAsset;
